import { Button } from '@repo/ui/components/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/components/card';
import { Input } from '@repo/ui/components/input';
import { Link } from '@tanstack/react-router';
import { Check, Copy, Gift, Heart, Share2 } from 'lucide-react';

import { useShareInvite } from '@/hooks/use-share-invite';

interface InvitePartnerEmptyStateProps {
  inviteToken?: string;
}

export function InvitePartnerEmptyState({
  inviteToken,
}: InvitePartnerEmptyStateProps) {
  const { inviteUrl, copied, handleCopy, handleShare } =
    useShareInvite(inviteToken);

  // If we have an invite token, show the pending invite state
  if (inviteToken) {
    return (
      <Card className="border-dashed">
        <CardHeader className="text-center">
          <div className="bg-primary/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <Heart className="text-primary h-8 w-8" />
          </div>
          <CardTitle>Compartilhe seu convite</CardTitle>
          <CardDescription>
            Envie esse link para seu amor para conectarem-se no eumimo
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-2">
            <Input value={inviteUrl} readOnly className="font-mono text-xs" />
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={handleCopy}
              title="Copiar link"
            >
              {copied ? (
                <Check className="h-4 w-4 text-green-500" />
              ) : (
                <Copy className="h-4 w-4" />
              )}
            </Button>
          </div>
          <Button onClick={handleShare} className="w-full">
            <Share2 className="mr-2 h-4 w-4" />
            Compartilhar
          </Button>
          <p className="text-muted-foreground text-center text-sm">
            Quando seu amor aceitar o convite, a lista de desejos dele(a)
            aparecerá aqui.
          </p>
        </CardContent>
      </Card>
    );
  }

  // No invitation available - shouldn't happen but fallback
  return (
    <Card className="border-dashed">
      <CardHeader className="text-center">
        <div className="bg-primary/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
          <Gift className="text-primary h-8 w-8" />
        </div>
        <CardTitle>Convide seu amor</CardTitle>
        <CardDescription>
          Para ver a lista de desejos do seu parceiro(a), você precisa
          convidá-lo(a) primeiro.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-center gap-2 text-sm">
          <Heart className="text-primary h-4 w-4" />
          <span className="text-muted-foreground">
            Compartilhem listas e nunca mais errem no presente
          </span>
        </div>
        <div className="flex justify-center">
          <Button asChild>
            <Link to="/onboarding">Convidar parceiro(a)</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
